import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { IDomainsSlice } from "@/redux/slices/domains/types";

type SearchDomainProps = {
  search: string;
  tlds: { tld: number }[];
};

export const customDomainSearch = createAsyncThunk(
  "domains/customDomainSearch",
  async ({ search, tlds }: SearchDomainProps) => {
    const response = await axios({
      method: "POST",
      url: "/api/domain-names/custom-search",
      data: {
        search,
        tlds: tlds.map((tld) => tld.tld),
      },
    });

    return response.data;
  }
);

const pending = (state: IDomainsSlice, { meta: { arg } }) => {
  state.search = {
    ...state.search,
    category: arg.category,
    value: arg.search,
    loading: true,
    results: {
      available: [],
      unavailable: [],
    },
  };
};

const fulfilled = (state: IDomainsSlice, { payload }) => {
  state.search = {
    ...state.search,
    loading: false,
    results: payload,
  };
};

const rejected = (state: IDomainsSlice) => {
  state.search = {
    ...state.search,
    loading: false,
    results: {
      available: [],
      unavailable: [],
      errorMessage: "Something went wrong",
    },
  };
};

export default {
  action: customDomainSearch,
  pending,
  fulfilled,
  rejected,
};
